<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #chainInput
          formControlName="chain" 
          [matAutocomplete]="chainAC" 
          [placeholder]="'LABEL_CHAIN' | translate"
          (focus)="!chainAC.isOpen && getInitialValues('chain')" 
          (blur)="checkAutocompleteObject(form, 'chain')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_chain_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="chainInput.blur(); clearForm($event)"
          *ngIf="chainInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!chainInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_chain_dropdown"
          [displayWith]="displayFn" 
          #chainAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); chainInput.blur()"
          (opened)="autocompleteScroll('chain','chainACRef','chainACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.chain && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_chain_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.chain" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('chain').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('chain').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_CHAIN' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>